export default "__VITE_ASSET__BWslcA9r__"